import React from "react";
import { Link } from "react-router-dom";


function Home() {

    return (
        <div className="detail-box">      
<h3 align="center">Events</h3>

<div className="home-category">2026</div>
    <ul className="gallery mw-gallery-traditional">
        <li className="gallerybox">
        <Link title="NYCC" to="/tags/NYCC%202026"><img alt="NYCC" className="where-image" src="logo_nycc.png"/><br/><div className="pinname"><b>NYCC 2026</b><br/>10/8/26</div></Link>
    </li>   
    <li className="gallerybox">
        <Link title="SWC" to="/tags/BlizzCon%202026"><img alt="BlizzCon" className="where-image" src="logo_blizzcon.png"/><br/><div className="pinname"><b>BlizzCon 2026</b><br/>9/12/26</div></Link>
    </li>  
    <li className="gallerybox">
        <Link title="NYCC" to="/tags/SDCC%202026"><img alt="SDCC" className="where-image" src="logo_sdcc.png"/><br/><div className="pinname"><b>SDCC 2026</b><br/>7/22/26</div></Link>
    </li>   

    </ul>

<div className="home-category">2025</div>
    <ul className="gallery mw-gallery-traditional">
        <li className="gallerybox">
        <Link title="NYCC" to="/tags/NYCC%202025"><img alt="NYCC" className="where-image" src="logo_nycc.png"/><br/><div className="pinname"><b>NYCC 2025</b><br/>10/9/25</div></Link>
    </li>   
    <li className="gallerybox">
        <Link title="NYCC" to="/tags/SDCC%202025"><img alt="SDCC" className="where-image" src="logo_sdcc.png"/><br/><div className="pinname"><b>SDCC 2025</b><br/>7/23/25</div></Link>
    </li>   
    <li className="gallerybox">
        <Link title="SWC" to="/tags/SWC 2025"><img alt="SWC" className="where-image" src="logo_swcjp.png"/><br/><div className="pinname"><b>SWC 2025</b><br/>4/18/25</div></Link>
    </li>  
    </ul>


<div className="home-category">2024</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox">
        <Link title="Anime Frontier" to="/tags/Anime%20Frontier%202024"><img alt="Anime Frontier" className="where-image" src="logo_animefrontier.png"/><br/><div className="pinname"><b>Anime Frontier 2024</b><br/>12/6/24</div></Link>
    </li>      
<li className="gallerybox">
        <Link title="NYCC" to="/tags/NYCC%202024"><img alt="NYCC" className="where-image" src="logo_nycc.png"/><br/><div className="pinname"><b>NYCC 2024</b><br/>10/17/24</div></Link>
    </li>    
    <li className="gallerybox">
        <Link title="Anime NYC" to="/tags/Anime%20NYC%202024"><img alt="Anime NYC" className="where-image" src="logo_animenyc.png"/><br/><div className="pinname"><b>Anime NYC 2024</b><br/>8/23/24</div></Link>
    </li>       
    <li className="gallerybox">
        <Link title="D23 Expo" to="/tags/D23%20Expo%202024"><img alt="D23 Expo" className="where-image" src="logo_d23.png"/><br/><div className="pinname"><b>D23 Expo 2024</b><br/>8/9/24</div></Link>
    </li>   
    <li className="gallerybox">
        <Link title="SDCC" to="/tags/SDCC%202024"><img alt="SDCC" className="where-image" src="logo_sdcc.png"/><br/><div className="pinname"><b>SDCC 2024</b><br/>7/24/24</div></Link>
    </li>    
    <li className="gallerybox">
        <Link title="Anime Expo" to="/tags/Anime Expo 2024"><img alt="Anime Expo" className="where-image" src="logo_animeexpo.png"/><br/><div className="pinname"><b>Anime Expo 2024</b><br/>7/4/24</div></Link>
    </li>      
    <li className="gallerybox">
        <Link title="LVL UP EXPO" to="/tags/LVL UP EXPO"><img alt="LVL UP EXPO" className="where-image" src="logo_lvlup.png"/><br/><div className="pinname"><b>LVL UP EXPO 2024</b><br/>4/26/24</div></Link>
    </li> 

    <li className="gallerybox">
        <Link title="WonderCon" to="/tags/C2E2 2024"><img alt="C2E2" className="where-image" src="logo_c2e2.png"/><br/><div className="pinname"><b>C2E2 2024</b><br/>4/26/24</div></Link>
    </li> 

    <li className="gallerybox">
        <Link title="WonderCon" to="/tags/Wondercon 2024"><img alt="WonderCon" className="where-image" src="logo_wondercon.png"/><br/><div className="pinname"><b>Wondercon 2024</b><br/>3/29/24</div></Link>
    </li>       
    <li className="gallerybox">
        <Link title="MegaCon Orlando" to="/tags/MegaCon Orlando 2024"><img alt="Wondercon" className="where-image" src="logo_megacon.png"/><br/><div className="pinname"><b>MegaCon Orlando 2024</b><br/>2/1/24</div></Link>
    </li> 
</ul>


<div className="home-category">2023</div>

    <ul className="gallery mw-gallery-traditional">
    <li className="gallerybox">
        <Link title="LACC" to="/tags/LACC%202023"><img alt="LACC" className="where-image" src="logo_lacc.png"/><br/><div className="pinname"><b>LACC 2023</b><br/>12/1/23</div></Link>
    </li>   
    <li className="gallerybox">
        <Link title="Anime NYC" to="/tags/Anime%20NYC%202023"><img alt="Anime NYC" className="where-image" src="logo_animenyc.png"/><br/><div className="pinname"><b>Anime NYC 2023</b><br/>11/17/23</div></Link>
    </li>        
    <li className="gallerybox">
        <Link title="TFon" to="/tags/TFCon%202023"><img alt="TFCon" className="where-image" src="logo_tfcon.png"/><br/><div className="pinname"><b>TFCon 2023</b><br/>10/20/23</div></Link>
    </li>   

    <li className="gallerybox">
        <Link title="NYCC" to="/tags/Alliance%20Fest%20NYCC%202023"><img alt="NYCC" className="where-image" src="logo_alliance_fest_nycc.png"/><br/><div className="pinname"><b>Alliance Fest NYCC 2023</b><br/>10/12/23</div></Link>
    </li>   
    <li className="gallerybox">
        <Link title="NYCC" to="/tags/NYCC%202023"><img alt="NYCC" className="where-image" src="logo_nycc.png"/><br/><div className="pinname"><b>NYCC 2023</b><br/>10/12/23</div></Link>
    </li>   
    <li className="gallerybox">
        <Link title="Power-Con" to="/tags/Power-Con%202023"><img alt="Power-Con" className="where-image" src="logo_powercon.png"/><br/><div className="pinname"><b>Power-Con 2023</b><br/>8/11/23</div></Link>
    </li>   
   
    <li className="gallerybox">
        <Link title="SDCC" to="/tags/Alliance%20Fest%20SDCC%202023"><img alt="SDCC" className="where-image" src="logo_alliance_fest_sdcc.png"/><br/><div className="pinname"><b>Alliance Fest SDCC 2023</b><br/>7/20/23</div></Link>
    </li>   

    <li className="gallerybox">
        <Link title="SDCC" to="/tags/SDCC%202023"><img alt="SDCC" className="where-image" src="logo_sdcc.png"/><br/><div className="pinname"><b>SDCC 2023</b><br/>7/19/23</div></Link>
    </li>    
    <li className="gallerybox">
        <Link title="Anime Expo" to="/tags/Anime Expo 2023"><img alt="Anime Expo" className="where-image" src="logo_animeexpo.png"/><br/><div className="pinname"><b>Anime Expo 2023</b><br/>7/1/23</div></Link>
    </li>      
    <li className="gallerybox">
        <Link title="Florida Supercon" to="/tags/Florida Supercon 2023"><img alt="Florida Supercon" className="where-image" src="logo_floridasupercon.png"/><br/><div className="pinname"><b>Florida Supercon 2023</b><br/>6/30/23</div></Link>
    </li>      
    <li className="gallerybox">
        <Link title="MomoCon" to="/tags/MomoCon 2023"><img alt="MomoCon" className="where-image" src="logo_momocon.png"/><br/><div className="pinname"><b>MomoCon 2023</b><br/>5/25/23</div></Link>
    </li>  
    <li className="gallerybox">
        <Link title="Anime Arizona" to="/tags/Anime Arizona 2023"><img alt="Anime Expo" className="where-image" src="logo_animearizona.png"/><br/><div className="pinname"><b>Anime Arizona 2023</b><br/>5/5/23</div></Link>
    </li>   
    <li className="gallerybox">
        <Link title="SWC" to="/tags/SWC 2023"><img alt="SWC" className="where-image" src="logo_swceu.png"/><br/><div className="pinname"><b>SWC 2023</b><br/>4/7/23</div></Link>
    </li>  
    <li className="gallerybox">
        <Link title="ECCC" to="/tags/ECCC%202023"><img alt="ECCC" className="where-image" src="logo_eccc.png"/><br/><div className="pinname"><b>ECCC 2023</b><br/>3/2/23</div></Link>
    </li>   
    </ul>

<div className="home-category">2022</div>
    <ul className="gallery mw-gallery-traditional">
    <li className="gallerybox">
        <Link title="LACC" to="/tags/LACC%202022"><img alt="LACC" className="where-image" src="logo_lacc.png"/><br/><div className="pinname"><b>LACC 2022</b><br/>12/2/22</div></Link>
    </li>   
    <li className="gallerybox">
        <Link title="Anime NYC" to="/tags/Anime%20NYC%202022"><img alt="Anime NYC" className="where-image" src="logo_animenyc.png"/><br/><div className="pinname"><b>Anime NYC 2022</b><br/>11/18/22</div></Link>
    </li>        
    <li className="gallerybox">
        <Link title="YCS" to="/tags/YCS Pasadena"><img alt="YCS" className="where-image" src="logo_ycs.png"/><br/><div className="pinname"><b>YCS Pasadena 2022</b><br/>11/5/22</div></Link>
    </li>  
    <li className="gallerybox">
        <Link title="NYCC" to="/tags/NYCC%202022"><img alt="NYCC" className="where-image" src="logo_nycc.png"/><br/><div className="pinname"><b>NYCC 2022</b><br/>10/6/22</div></Link>
    </li>        
    <li className="gallerybox">
        <Link title="D23 Expo" to="/tags/D23%20Expo%202022"><img alt="D23 Expo" className="where-image" src="logo_d23.png"/><br/><div className="pinname"><b>D23 Expo 2022</b><br/>9/9/22</div></Link>
    </li>    
    <li className="gallerybox">
        <Link title="ECCC" to="/tags/ECCC%202022"><img alt="ECCC" className="where-image" src="logo_eccc.png"/><br/><div className="pinname"><b>ECCC 2022</b><br/>8/18/22</div></Link>
    </li>   
    <li className="gallerybox">
        <Link title="Crunchyroll Expo" to="/tags/Crunchyroll Expo"><img alt="Crunchyroll Expo" className="where-image" src="logo_crx.png"/><br/><div className="pinname"><b>Crunchyroll Expo 2022</b><br/>8/5/22</div></Link>
    </li>    
    <li className="gallerybox">
        <Link title="SDCC" to="/tags/SDCC%202022"><img alt="SDCC" className="where-image" src="logo_sdcc.png"/><br/><div className="pinname"><b>SDCC 2022</b><br/>7/20/22</div></Link>
    </li>    
    <li className="gallerybox">
        <Link title="Anime Expo" to="/tags/Anime Expo 2022"><img alt="Anime Expo" className="where-image" src="logo_animeexpo.png"/><br/><div className="pinname"><b>Anime Expo 2022</b><br/>7/1/22</div></Link>
    </li>      
    <li className="gallerybox">
        <Link title="FiGPiN Event" to="/set/FWAP%202022%20Set"><img alt="FiGPiN Event" className="where-image" src="logo_figpin.png"/><br/><div className="pinname"><b>FWAP 2022</b><br/>6/25/22</div></Link>
    </li>    
    <li className="gallerybox">
        <Link title="SWC" to="/tags/SWC 2022"><img alt="SWC" className="where-image" src="logo_swc.png"/><br/><div className="pinname"><b>SWC 2022</b><br/>5/26/22</div></Link>
    </li>  
    <li className="gallerybox">
        <Link title="SWC" to="/tags/Wondercon 2022"><img alt="Wondercon" className="where-image" src="logo_wondercon.png"/><br/><div className="pinname"><b>Wondercon 2022</b><br/>4/1/22</div></Link>
    </li>       
    </ul>
    

    <div className="home-category">2021</div>
    <ul className="gallery mw-gallery-traditional">
    <li className="gallerybox">
        <Link title="ECCC" to="/tags/ECCC%202021"><img alt="ECCC" className="where-image" src="logo_eccc.png"/><br/><div className="pinname"><b>ECCC 2021</b><br/>12/2/21</div></Link>
    </li>        
    <li className="gallerybox">
        <Link title="SDCC" to="/tags/SDCC%202021"><img alt="SDCC" className="where-image" src="logo_sdcc.png"/><br/><div className="pinname"><b>SDCC SE 2021</b><br/>11/26/21</div></Link>
    </li>    
    <li className="gallerybox">
        <Link title="NYCC" to="/tags/NYCC%202021"><img alt="NYCC" className="where-image" src="logo_nycc.png"/><br/><div className="pinname"><b>NYCC 2021</b><br/>10/7/21</div></Link>
    </li>        
    <li className="gallerybox">
        <Link title="MLB" to="/pinDetail/808"><img alt="MLB" className="where-image" src="logo_mlb.png"/><br/><div className="pinname"><b>SF Giants Bruce Lee</b><br/>9/15/21</div></Link>
    </li> 
</ul>


<div className="home-category">2020</div>
    <ul className="gallery mw-gallery-traditional">
    <li className="gallerybox">
        <Link title="ECCC" to="/tags/ECCC%202020"><img alt="ECCC" className="where-image" src="logo_eccc.png"/><br/><div className="pinname"><b>ECCC 2020</b><br/>4/8/20 (Sold Online)</div></Link>
    </li>        
    <li className="gallerybox">
        <Link title="FiGPiN Event" to="/tags/AwesomeFest"><img alt="FiGPiN Event" className="where-image" src="logo_figpin.png"/><br/><div className="pinname"><b>AwesomeFest 2020</b><br/>4/2/20 (Sold Online)</div></Link>
    </li>   
</ul>

<div className="home-category">2019</div>
    
    <ul className="gallery mw-gallery-traditional">
    <li className="gallerybox">
        <Link title="DCON" to="/tags/DesignerCon"><img alt="DCON" className="where-image" src="logo_dcon.png"/><br/><div className="pinname"><b>DCON 2019</b><br/>11/22/19</div></Link>
    </li>        
    <li className="gallerybox">
        <Link title="LACC" to="/tags/LACC%202019"><img alt="LACC" className="where-image" src="logo_lacc.png"/><br/><div className="pinname"><b>LACC 2019</b><br/>10/11/19</div></Link>
    </li>     
    <li className="gallerybox">
        <Link title="NYCC" to="/tags/NYCC%202019"><img alt="NYCC" className="where-image" src="logo_nycc.png"/><br/><div className="pinname"><b>NYCC 2019</b><br/>10/3/19</div></Link>
    </li>     
    <li className="gallerybox">
        <Link title="D23 Expo" to="/tags/D23%20Expo%202019"><img alt="D23 Expo" className="where-image" src="logo_d23.png"/><br/><div className="pinname"><b>D23 Expo 2019</b><br/>8/23/19</div></Link>
    </li>    
    <li className="gallerybox">
        <Link title="SDCC" to="/tags/SDCC%202019"><img alt="SDCC" className="where-image" src="logo_sdcc.png"/><br/><div className="pinname"><b>SDCC 2019</b><br/>7/21/19</div></Link>
    </li>    
    <li className="gallerybox">
        <Link title="Anime Expo" to="/tags/Anime Expo 2019"><img alt="Anime Expo" className="where-image" src="logo_animeexpo.png"/><br/><div className="pinname"><b>Anime Expo 2019</b><br/>7/3/19</div></Link>
    </li>   

    <li className="gallerybox">
        <Link title="ECCC" to="/tags/Fan%20Expo%20Dallas%202019"><img alt="Fan Expo Dallas" className="where-image" src="logo_fanexpodallas.png"/><br/><div className="pinname"><b>Fan Expo Dallas 2019</b><br/>5/3/19</div></Link>
    </li>    

    <li className="gallerybox">
        <Link title="ECCC" to="/tags/ECCC%202019"><img alt="ECCC" className="where-image" src="logo_eccc.png"/><br/><div className="pinname"><b>ECCC 2019</b><br/>3/14/19</div></Link>
    </li>        

</ul>


<div className="home-category">2018</div>
    
    <ul className="gallery mw-gallery-traditional">
    <li className="gallerybox">
        <Link title="NYCC" to="/tags/NYCC%202018"><img alt="NYCC" className="where-image" src="logo_nycc.png"/><br/><div className="pinname"><b>NYCC 2018</b><br/>10/4/18</div></Link>
    </li>    
    <li className="gallerybox">
        <Link title="SDCC" to="/tags/SDCC%202018"><img alt="SDCC" className="where-image" src="logo_sdcc.png"/><br/><div className="pinname"><b>SDCC 2018</b><br/>7/19/18</div></Link>
    </li>    
</ul>

<div className="home-category">2017</div>
    
    <ul className="gallery mw-gallery-traditional">
    <li className="gallerybox">
        <Link title="NYCC" to="/tags/NYCC%202017"><img alt="NYCC" className="where-image" src="logo_nycc.png"/><br/><div className="pinname"><b>NYCC 2017</b><br/>10/5/17</div></Link>
    </li>    
    <li className="gallerybox">
        <Link title="SDCC" to="/tags/SDCC%202017"><img alt="SDCC" className="where-image" src="logo_sdcc.png"/><br/><div className="pinname"><b>SDCC 2017</b><br/>7/20/17</div></Link>
    </li>    
</ul>
        </div>
    );
}

export default Home;